import React from "react";
import Icon from "images/icons/gray/arrow-expand.svg";
import { Wrapper, Image } from "./styled";

const ArrowExpandIcon = ({ onClick }) => {
  return (
    <Wrapper onClick={onClick}>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default ArrowExpandIcon;
